<div class="transcription-tools-container">
	<div class="d-flex justify-content-between align-items-center">
		<span class="title" mat-dialog-title>{{ 'TRANSCRIPTIONS.TOOLS' | translate }}</span>
		<button mat-icon-button (click)="closeDialog()" class="d-flex justify-content-center align-items-center me-4">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="m-0 p-4">
		<form [formGroup]="formGroup">
			<mat-form-field class="w-50 pb-2">
				<mat-label>{{ 'ASSORTED.SELECT_OPTION' | translate }}</mat-label>
				<select id="select-tool" style="display: none"></select>
				<!-- workaround for material-chrome bug -->
				<mat-select id="select-tool" placeholder="{{ 'ASSORTED.SELECT_OPTION' | translate }}" formControlName="tool" (selectionChange)="onSelectTool()">
					@for (value of tools; track $index) {
					<mat-option [value]="value">{{ 'TRANSCRIPTIONS.' + value | translate }}</mat-option>
					}
				</mat-select>
			</mat-form-field>

			@if (showDateRange) {
			<div class="pb-2">
				<mat-form-field class="w-50">
					<mat-date-range-input [formGroup]="dateRangePicker" color="primary" [rangePicker]="picker">
						<input formControlName="dateFrom" matStartDate placeholder="{{ 'TRANSCRIPTIONS.DATE_FROM' | translate }}" />
						<input formControlName="dateTo" matEndDate placeholder="{{ 'TRANSCRIPTIONS.DATE_TO' | translate }}" />
					</mat-date-range-input>
					<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
					<mat-date-range-picker #picker>
						<mat-date-range-picker-actions>
							<button mat-button matDateRangePickerCancel>{{ 'BUTTON.CANCEL' | translate }}</button>
							<button mat-raised-button color="primary" matDateRangePickerApply>{{ 'BUTTON.APPLY' | translate }}</button>
						</mat-date-range-picker-actions>
					</mat-date-range-picker>
				</mat-form-field>
			</div>
			}
		</form>
	</mat-dialog-content>

	<mat-dialog-actions [align]="'end'">
		<mat-divider class="w-100 my-2"></mat-divider>

		<button mat-flat-button color="warn" (click)="buttonAction()" [disabled]="formGroup.invalid">
			{{ 'BUTTON.CONFIRM' | translate }}
		</button>

		<button mat-flat-button color="primary" (click)="closeDialog()">
			{{ 'BUTTON.CANCEL' | translate }}
		</button>
	</mat-dialog-actions>
</div>
